// @index(!registry): import ${relpath}
import './DataFieldForm'
import './RelatedFieldForm'
import './RelatedToggleFieldForm'

// /index

export { getImportFieldFormComponent } from './registry'